import { useEffect, useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import BasicProcessingModal from "../../../../components/LoadingModal/BasicProcessingModal";

const InfoTitulosModal = ({ show, numTitulo, handleCloseModal }) => {
  const [titleHasData, setTitleHasData] = useState(false);
  const [titleData, setTitleData] = useState({});
  const [modalStatus, setModalStatus] = useState({ status: null, message: "" });

  const {
    register,
    handleSubmit,
    reset,
    formState: { dirtyFields },
  } = useForm();

  useEffect(() => {
    const getData = async () => {
      if (!show || !numTitulo) return;
      setModalStatus({ status: "processing", message: "Cargando" });
      let response = await CreacionTitulosService.getTitleInfo(
        `numberTitle=${numTitulo}`
      );
      if (response?.data?.titulo_data) {
        const data = response.data.titulo_data;
        setTitleData(response.data);
        reset({
          nombre_contribuyente: data.nombre_contribuyente || "",
          cuit_contribuyente: data.cuit_contribuyente || "",
          calle: data.calle || "",
          numero_calle: data.numero_calle || "",
          cod_postal: data.cod_postal || "",
          ciudad: data.ciudad || "",
          provincia: data.provincia || "",
          total_general_letras: data.total_general_letras || "",
        });
        setTitleHasData(true);
        setModalStatus({ status: "success", message: "", time: 1 });
      }
      setModalStatus({
        status: "error",
        message: "Excel Procesado con éxito!!",
        time: 1,
      });
    };
    getData();
  }, [show, numTitulo, reset]);

  const onSubmit = async (formData) => {
    try {
      let dataToSend = { numTitulo };

      for (const key in dirtyFields) {
        if (Object.prototype.hasOwnProperty.call(formData, key)) {
          dataToSend = {
            ...dataToSend,
            data: { ...dataToSend.data, [key]: formData[key] },
          };
        }
      }

      const response = await CreacionTitulosService.updateTitleInfo(dataToSend);

      // Extraer el filename desde headers
      const disposition = response.headers["content-disposition"];
      let filename = "archivo.pdf";

      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .split(";")[0]
          .replace(/["']/g, "");
      }

      const blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      handleCloseModal();
    } catch (error) {
      console.log("Error en el submit", error);
    }
  };

  return (
    <ModalOverlay show={show}>
      <ModalContainer>
        <ModalTitle closeButton>Información del título</ModalTitle>
        {titleHasData ? (
          <ModalInfo>
            <ModalStaticInfo>
              <Row>
                <BoldText>Nombre Abogado:</BoldText>{" "}
                {titleData.abogado.apellido + ", " + titleData.abogado.nombre}
                <BoldText>DNI Abogado:</BoldText> {titleData.abogado.nrodni}
                <BoldText>Abogado Cod. Externo:</BoldText>{" "}
                {titleData.abo_codexterno}
              </Row>
              <Row>
                <BoldText>Nro. Título:</BoldText>{" "}
                {titleData.titulo_data.num_titulo}
                <BoldText>Categoría:</BoldText>{" "}
                {titleData.titulo_data.category.charAt(0).toUpperCase() +
                  titleData.titulo_data.category.slice(1)}
                <BoldText>Nro. Inmueble:</BoldText>{" "}
                {titleData.titulo_data.nro_inmueble}
              </Row>
              <Row>
                <BoldText>Recurso:</BoldText> {titleData.titulo_data.recurso}
                <BoldText>Nombre Recurso:</BoldText>{" "}
                {titleData.titulo_data.nombre_recurso}
                <BoldText>Total Deuda:</BoldText> $
                {titleData.titulo_data.total_general}
              </Row>
              <Row>
                <BoldText>Creador:</BoldText>{" "}
                {titleData.usuario.apellido + ", " + titleData.usuario.nombre}
                <BoldText>DNI Creador:</BoldText> {titleData.usuario.usuario}
                <BoldText>Fecha y Hora Creación:</BoldText>{" "}
                {titleData.fecha_creacion + " " + titleData.hora_creacion}
              </Row>
            </ModalStaticInfo>
            <ModalForm onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">
                    Nombre Contribuyente:{" "}
                  </Label>
                  <Input
                    // name="nombre_contribuyente"
                    // value = {register("nombre_contribuyente")}
                    {...register("nombre_contribuyente")}
                  />
                </Col>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">CUIT: </Label>
                  <Input
                    // name="cuit_contribuyente"
                    {...register("cuit_contribuyente")}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">Calle: </Label>
                  <Input
                    // name="calle"
                    {...register("calle")}
                  />
                </Col>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">Nro.: </Label>
                  <Input
                    // name="numero_calle"
                    {...register("numero_calle")}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">Ciudad: </Label>
                  <Input
                    // name="ciudad"
                    {...register("ciudad")}
                  />
                </Col>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">Cod. Postal: </Label>
                  <Input
                    // name="cod_postal"
                    type="number"
                    {...register("cod_postal")}
                  />
                </Col>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">Provincia: </Label>
                  <Input
                    // name="provincia"
                    {...register("provincia")}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={6} md={6} className="mt-3">
                  <Label className="text-uppercase mb-2">
                    Monto en Letras:{" "}
                  </Label>
                  <Input
                    // name="total_general_letras"
                    {...register("total_general_letras")}
                  />
                </Col>
              </Row>

              <Row className="justify-content-center pt-4">
                <Button
                  type="submit"
                  disabled={Object.keys(dirtyFields).length === 0}
                >
                  {"Actualizar"}
                </Button>

                <Button
                  style={{ maxWidth: 190 }}
                  variant="danger"
                  onClick={handleCloseModal}
                >
                  <span>Cerrar</span>
                </Button>
              </Row>
            </ModalForm>
          </ModalInfo>
        ) : (
          <ModalNoInfo>
            <ModalTitle>Título creado anteriormente.</ModalTitle>
            <ModalTitle>No se encontró información</ModalTitle>
            <Button
              style={{ maxWidth: 190 }}
              variant="danger"
              onClick={handleCloseModal}
            >
              <span>Cerrar</span>
            </Button>
          </ModalNoInfo>
        )}
      </ModalContainer>
      <BasicProcessingModal
        status={modalStatus}
        onClose={() => setModalStatus({ status: undefined, message: "" })}
      />
    </ModalOverlay>
  );
};

export default InfoTitulosModal;

const ModalOverlay = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContainer = styled.div`
  background: white;
  padding: 30px;
  width: 80%;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const ModalTitle = styled.h2`
  text-align: center;
`;

const ModalForm = styled.form``;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`;

const Col = styled.div`
  flex: 1 1 45%;
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: bold;
  margin-bottom: 8px;
  text-transform: uppercase;
`;

const Input = styled.input`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

// const ButtonRow = styled.div`
//   margin-top: 24px;
//   display: flex;
//   justify-content: center;
//   gap: 16px;
// `;

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background-color: ${({ variant, disabled }) =>
    disabled ? "#ccc" : variant === "danger" ? "#dc3545" : "#007bff"};
  color: white;

  &:hover {
    opacity: ${({ disabled }) => (disabled ? "1" : "0.7")};
  }
`;

// const CloseButton = styled.button`
//   position: absolute;
//   top: 20px;
//   right: 30px;
//   font-size: 24px;
//   background: none;
//   border: none;
//   cursor: pointer;
// `;

const ModalNoInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalStaticInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BoldText = styled.p`
  font-weight: bold;
`;

// const InfoRow = styled.div`
//   margin-bottom: 8px;
// `;
